import Theme from "./Theme"
import Logo from "./Logo"
import FavsShow from "./FavsShow"

const Header = () => <div className='pr-3 pl-8 h-16 flex items-center justify-between z-20'>
    <div className='flex gap-2 items-center'>
        <Logo /><a className='minititle' href='//www.csshero.org/?rid=39626' target='_blank'>by CSS Hero</a>
    </div>
    <div className='minititle'>Hit spacebar to randomize</div>
    <div className='flex font-semibold items-center'>
        <Theme />
        <FavsShow />
    </div>
</div>

export default Header
